module.exports = __webpack_public_path__ + "static/media/favicon.cc148eff.ico";